// WU-2.3 — directed supervisor→operator notes. Cross-layer types shared by
// api routes/service and the web feature (AnnouncementRecord precedent).
// Spec: docs/superpowers/specs/2026-07-06-wu23-directed-notes-design.md
export const DIRECTED_NOTE_BODY_MAX = 500;
export const DIRECTED_NOTE_REPLY_MAX = 500;
export function directedNoteState(n) {
    if (n.retractedAt)
        return "retracted";
    if (n.acknowledgedAt)
        return "acknowledged";
    return "active";
}
export function isDirectedNoteActive(n) {
    return directedNoteState(n) === "active";
}
/**
 * The per-user WS channel. Auto-subscribed at socket auth (websocket.ts);
 * the ONLY place channel-name format lives. Private in transit — note
 * bodies never ride tenant-wide channels.
 */
export function userChannel(tenantId, userId) {
    return `user:${tenantId}:${userId}`;
}
//# sourceMappingURL=directed-notes.js.map